import { Button } from "../../../../core/components/atoms/Button";
import { Icon } from "../../../../core/components/atoms/Icon";
import { useGetPracticeRevision } from "../../hooks/getPracticeRevision";
import { Fragment, useEffect, useState } from "react";
import { Toast, toast } from "../../../../core/components/atoms/Toast";
import { practiceRevisionStore } from "../../stores/practiceRevisionStore";
import RevisionList from "../../../../core/components/organism/RevisionList";
import HeaderRevision from "../HeaderRevision";
import { useDeletePracticeRevision } from "../../hooks/deleteRevision";
import { useNavigate } from "react-router-dom";
import ModalFilterRevision from "../RevisionFilterModal";
import { useGetPracticeAreas } from "../../hooks/getPracticeAreas";
import { EmptyState } from "../EmptyState";
import { Typography } from "../../../../core/components/molecules/Typography";
import { Modal } from "../../../../core/components/templates/Modal";

export function PracticeRevisions() {
  const navigate = useNavigate();
  useGetPracticeAreas()
  const { mutate, isPending, isError } = useGetPracticeRevision()
  const { mutate: deleteRevision, isPending: loadingDelete, data, isSuccess  } = useDeletePracticeRevision()
  const { practiceRevision } = practiceRevisionStore();

  const [willDeleteId, setWillDeleteId] = useState<string>();
  const [willDeleteTitle, setWillDeleteTitle] = useState<string>();
  const [isOpenDeleteConfirmation, setIsOpenDeleteConfirmation] = useState<boolean>(false);
  const [isOpenFilter, setIsOpenFilter] = useState<boolean>(false);

  const handleDelete = () => {
    if(willDeleteId) {
      deleteRevision(willDeleteId);
    }
  }

  const openDelete = (id: string, title?: string) => {
    if(title) {
      setWillDeleteTitle(title);
    }

    setWillDeleteId(id)
    setIsOpenDeleteConfirmation(true)
  }

  const closeDelete = () => {
    setWillDeleteId(undefined);
    setWillDeleteTitle(undefined);
    setIsOpenDeleteConfirmation(false);
  }

  const handleSubmitFilter = () => {
    mutate()
    setIsOpenFilter(false);
  }

  useEffect(() => {
    mutate()
  }, [])

  useEffect(() => {
    if(isSuccess && !data.display) {
      mutate();
      const subject = willDeleteTitle;

      closeDelete();
      toast({ 
        variant: 'success', 
        message: `Assunto ${subject} removido da lista de revisões`,
        title: 'Sucesso!' 
      })
    }
  }, [loadingDelete])

  useEffect(() => {
    if(isError) {
      toast({ 
        variant: 'error', 
        message: 'Não foi possivel buscar seus simulados', 
        title: 'Erro!' 
      })
    }
  }, [isError])

  return (
    <div className="mt-8 flex flex-col gap-xxl">
      {isError && <Toast />}
      <div className="flex xs:flex-col lg:flex-row xs:items-start gap-lg lg:items-center justify-between ">
        <HeaderRevision 
          title="Revisões" 
          text="Confira os assuntos que precisam de revisão baseado em seu aproveitamento nos simulados"
        />
        <Button
          variant='text'
          onClick={() => setIsOpenFilter(true)}
          className='p-0'
        >
          <Icon
            Icon='filter_list'
            type='material'
            className='xs:text-sm md:text-md'
          />
          <span className='xs:text-sm md:text-md '>
            Filtrar revisões
          </span>
        </Button>
      </div>
      {practiceRevision.length === 0 || !practiceRevision ? (
        <EmptyState 
          text="A lista de revisão ainda está vazia"
          subtext="Seus assuntos para revisar aparecerão aqui após você realizar os simulados criados"
        />
      ) : (
        <Fragment>
          <RevisionList 
            title="Revise agora"
            isLoading={isPending}
            data={practiceRevision.filter((it) => it.futureRevision === false)}
            onExclude={(id: string, title: string) => openDelete(id, title)}
            onRevision={(id: string) => navigate('/simulados/revisao/'+id)}
          />
          <RevisionList 
            title="Revise depois"
            isLoading={isPending}
            data={practiceRevision.filter((it) => it.futureRevision === true)}
            onExclude={(id: string, title: string) => openDelete(id, title)}
            onRevision={(id: string) => navigate('/simulados/revisao/'+id)}
          />
        </Fragment>
      )}
      <Modal
        isOpen={isOpenDeleteConfirmation}
        onClose={() => closeDelete()}
        position="center"
        className="p-0 xs:w-full lg:w-2/5"
      >
        <div className="flex flex-col gap-xl">
          <Typography>
            Tem certeza que deseja excluir o assunto {willDeleteTitle} da sua lista de revisões?
          </Typography>
          <div className="flex flex-row items-center justify-end gap-sm">
            <Button variant="text" onClick={() => closeDelete()}>
              Voltar
            </Button>
            <Button loading={loadingDelete} variant="text" onClick={() => handleDelete()}>
              Excluir assunto
            </Button>
          </div>        
        </div>
      </Modal>
      <ModalFilterRevision 
        isOpen={isOpenFilter}
        onClose={() => setIsOpenFilter(false)}
        onSubmit={() => handleSubmitFilter()}
      />
    </div>
  )
}